<template>
  <div id="user-dropdown">
    <button @click="toggleMenu">
      <div class="user">
        <AccountImage 
          :has-img = "account.has_img" 
          :account-id = "account.id" 
          :account-name = "account.last_name + account.first_name" />
      </div>
    </button>
    <div class="menu" v-show="Boolean(data.menuDisplay)" @mouseleave="onMouseleave">
      <router-link to = "/admin" v-if="loginFlg && account.admin_flg">
        <font-awesome-icon icon="tools" v-tooltip="'管理メニュー'" class="header-menu-icon" />管理メニュー
      </router-link>
      <router-link to="/settings">
        <font-awesome-icon icon="user-cog" v-tooltip="'設定'" class="header-menu-icon" />設定
      </router-link>
      <LogoutAnchor :icon="true" />
    </div>
  </div>
</template>
<script setup>
import { computed, reactive } from "vue"
import { useStore } from 'vuex'
import AccountImage from '../../image/AccountImage.vue'
import LogoutAnchor from '../LogoutAnchor.vue'

// store取得
const $store = useStore()

// --- define state ---
const data = reactive({
  menuDisplay: false
})

// --- computed ---
const account = computed(() => $store.state.core.account)
const loginFlg = computed(() => $store.state.core.loginFlg)

// --- methods ---
const toggleMenu = () => {
  data.menuDisplay = !data.menuDisplay
}
const onMouseleave = () => {
  data.menuDisplay = false
}
</script>
<!-- <script>
import { mapState } from 'vuex'
import LogoutAnchor from '../logout-anchor'

export default {
  data () {
    return {
      menuDisplay : false
    }
  },
  computed: {
    ...mapState([
      'loginFlg',
      'account'
    ]),
  },
  methods : {
    toggleMenu : function () {
      this.menuDisplay = !this.menuDisplay
    },
    onMouseleave : function () {
      this.menuDisplay = false
    }
  },
  components : {
    'c-logout-anchor' : LogoutAnchor,
  }
}
</script> -->
